import React from 'react';
import Layout from 'components/Layout';
import Page from 'components/Page';
import { infopagesItemsRequest } from 'actions/pagesActions';
import { setBreadcrumbs } from 'actions/app/breadcrumbs';

import notFount from '../not-found';
import { resolve } from './urls';

async function action({ path, fetch, store }) {
  const { items } = await infopagesItemsRequest(fetch, {
    fields: '"html"',
    slug: `"${resolve(path)}"`,
  });

  if (items.length === 0) {
    return notFount();
  }

  const { title, html, meta: { seo_description: description } } = items[0];

  store.dispatch(
    setBreadcrumbs([{ title: 'Avtoprod', href: '/' }, { title, active: true }]),
  );

  return {
    chunks: ['site'],
    title,
    description,
    component: (
      <Layout>
        <Page html={html} title={title} setStyles />
      </Layout>
    ),
  };
}

export default action;
